<template>
  <!--创建/编辑话题-->
  <div aria-labelledby="myModalLabel" class="modal fade" id="newtopic" role="dialog" tabindex="-1">
    <div class="modal-dialog modal-size" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <i class="iconfont icon-close"></i>
          </button>
          <h4 class="modal-title" id="myModalLabel">{{textMap[dialogStatus]}}</h4>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <input
              class="form-control"
              placeholder="话题名称"
              type="text"
              v-model="topic.title"
              name="title"
              data-vv-as="话题名称 "
              v-validate="{ required:true, min:1,max:100 }"
            />
            <span class="help-block" v-show="errors.has('title')">{{ errors.first('title') }}</span>
          </div>
          <div class="form-group">
            <div ref="topicEditor"></div>
            <span class="help-block" v-show="errors.has('content')">{{ errors.first('content') }}</span>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-default" data-dismiss="modal" type="button">取消</button>
          <button
            class="btn btn-primary"
            type="button"
            @click="createTopic"
            v-if="dialogStatus === 'create'"
          >创建</button>
          <button class="btn btn-primary" type="button" @click="editTopic" v-else>编辑</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let editor = null;
import E from "wangeditor";
import { createTopic, editTopic } from "@/api/topic/topic";
export default {
  name: "GroupTopicCreate",
  data() {
    return {
      textMap: {
        update: "编辑话题",
        create: "创建话题"
      }
    };
  },
  props: {
    dialogStatus: {
      type: String,
      default: "create"
    },
    group_number: {
      type: String
    },
    temp: {
      type: Object
    }
  },
  computed: {
    topic() {
      return {
        title: this.temp.topic_title,
        content: this.temp.topic_content
      };
    }
  },
  methods: {
    createTopic() {
      this.$validator.validate().then(valid => {
        if (valid) {
          if (!this.topic.content || this.topic.content === "<p><br></p>") {
            this.errors.add({
              field: "content",
              msg: "话题内容不能为空"
            });
            return false;
          }
          createTopic({
            topic_title: this.topic.title,
            topic_content: this.topic.content,
            topic_object_type: "group",
            topic_object_number: this.group_number
          })
            .then(res => {
              if (res.status_code === 200) {
                $("#newtopic").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.$emit("refreshTopic");
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    },
    editTopic() {
      this.$validator.validate().then(valid => {
        if (valid) {
          editTopic({
            topic_title: this.topic.title,
            topic_content: this.topic.content,
            topic_number: this.temp.topic_number
          })
            .then(res => {
              if (res.status_code === 200) {
                $("#newtopic").modal("hide");
                this.$message({
                  type: "success",
                  message: res.message
                });
                this.$emit("refreshTopic");
              } else {
                this.$message({
                  type: "error",
                  message: res.message
                });
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err
              });
            });
        }
      });
    }
  },
  mounted() {
    editor = new E(this.$refs.topicEditor);
    editor.customConfig.onchange = html => {
      this.topic.content = html;
    };
    editor.customConfig.onfocus = () => {
      if (
        editor.txt.html() ===
        '<br><div><span style="color:#989898;font-size:small;">写点什么...</span><br></div>'
      ) {
        this.topic.content = "<p><br></p>";
        editor.txt.html("<p><br></p>");
      }
      this.errors.remove("content");
    };
    editor.create();
    $("#newtopic").on("shown.bs.modal", () => {
      if (this.topic.content) {
        editor.txt.html(this.topic.content);
      } else {
        editor.txt.html(
          '<br><div><span style="color:#989898;font-size:small;">写点什么...</span><br></div>'
        );
      }
    });
    $("#newtopic").on("show.bs.modal", () => {
      this.$validator.reset();
    });
    $("#newtopic").on("hidden.bs.modal", () => {
      editor.txt.clear();
    });
  }
};
</script>

<style scoped>
.modal-size {
  width: 750px;
}
</style> 